import { HTTP, buildQueries } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachCapDonVi(payload) {
  return HTTP({
    url: ENDPOINT.CAP_DON_VI.ALL,
    method: "GET",
    params: payload
  });
}

export function callApiTaoCapDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.CAP_DON_VI.CRUD, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function callApiSuaCapDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.CAP_DON_VI.CRUD, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function callApiXoaCapDonVi(payload) {
  return HTTP({
    url: ENDPOINT.CAP_DON_VI.CRUD,
    method: "DELETE",
    params: payload
  });
}

export function callApiCapNhatThuTu(payload) {
  return HTTP({
    url: ENDPOINT.CAP_DON_VI.ORDER,
    method: "PATCH",
    data: payload
  });
}

export function callApiLayDanhSachCapDonViPaging(payload) {
  return HTTP({
    url: ENDPOINT.CAP_DON_VI.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiLayThuTuMacDinh(payload) {
  console.log(
    "ENDPOINT.CAP_DON_VI.LAY_THU_TU_MAC_DINH",
    ENDPOINT.CAP_DON_VI.LAY_THU_TU_MAC_DINH
  );
  return new Promise((resolve, reject) => {
    console.log(payload);
    return HTTP.get(
      `${ENDPOINT.CAP_DON_VI.LAY_THU_TU_MAC_DINH}?${buildQueries(payload)}`
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
